import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { useSrOnlyStyles } from '@/theme/srOnly';

const useStyles = makeStyles({
  asterisk: {
    color: tokens.colorStatusDangerForeground1,
    marginInlineStart: tokens.spacingHorizontalXXS,
  },
});

export function RequiredIndicator(): React.ReactElement {
  const styles = useStyles();
  const srOnlyStyles = useSrOnlyStyles();
  return (
    <>
      <span className={styles.asterisk} aria-hidden="true">*</span>
      <span className={srOnlyStyles.srOnly}>{' required'}</span>
    </>
  );
}
